import { IApp03WorkItemType, IEntityChildren } from '../types';
import { EntityService } from './EntityService';

export class App03WorkItemTypeService extends EntityService<IApp03WorkItemType> {

    protected childrenEntities = [
        'App03Tasks',
    ];


    constructor() {
        super(`/App03WorkItemTypes`);
    }

    public readAllForList(templateID?: number): Promise<IApp03WorkItemType[]> {
        return this.readAll(
            `?$select=ID,Title,IsDefault,SystemType`
            + `&$orderby=ID`
            + `&$filter=App03TemplateID eq ${templateID}`
        );
    }

    public readAllForDropList(templateID?: number): Promise<IApp03WorkItemType[]> {
        return this.readAll(
            `?$select=ID,Title,IsDefault`
            + `&$orderby=ID`
            + `&$filter=App03TemplateID eq ${templateID}`
        );
    }

    public async countWorkItemTypesForTemplate(templateID: number): Promise<number> {
        if (templateID) {
            return (await this.readAll(`?$select=ID&$filter=App03TemplateID eq ${templateID}`))?.length;
        }
        return Promise.resolve(0);
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const tasks = (await this.axiosGet(`${entityUrl}/App03Tasks?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Work Items', CanBeAdopted: false, ChildIDs: (await tasks).map((m: { ID: any }) => m.ID) },
        ];
    }
}